import { FormattedMessage } from 'react-intl';

export const ManNowRenewalInfoMessage = () => (
    <FormattedMessage
        id='intl-msg:marketplace.contracts.mannow.renew.dialog.decommissioned'
        values={{
            marketplace: chunks => <>{chunks}</>,
            manNow: chunks => <>{chunks}</>,
        }}
    />
);
